<template>
  <component :is="component" :curationData="curationData" :paginationData="paginationData" v-if="component"/>
</template>

<script>
export default {
  name: "CurationListLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    listLayout: {},
    curationData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.listLoader();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/curation/list/${this.listLayout}`)
    },
  },
  methods:{
    listLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/curation/list/CurationListDefaultLayout')
          })
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>